import { date, money0 } from "@keel/core";
import { Stat } from "@keel/ui";

interface Next {
  id: string;
  period: string;
  payDate: string;
  status: string;
  net: number;
  employees: number;
  errors: number;
}

/** Home dashboard: the next pay run (totals only). */
export function PayrollTile({ data }: { data: { next: Next | null } }) {
  const n = data.next;
  if (!n) return <Stat label="Next payroll" value="—" href="/payroll" foot="No run open" />;
  return (
    <Stat
      label="Next payroll"
      value={money0(n.net)}
      href={`/payroll/runs/${n.id}`}
      tone={n.errors ? "danger" : undefined}
      foot={`${n.employees} people · pay day ${date(n.payDate)}${n.errors ? ` · ${n.errors} to fix` : n.status === "draft" ? " · not posted" : ""}`}
    />
  );
}
